var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",attrs:{"row-key":"default_item_id","split-count":10,"url":_vm.table_url,"setting":_vm.setting,"fixed-row-action":"","reserve-selection":"","hooks":{
      beforeSearch: _vm.beforeSearch,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }